var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"p-footer"},[_c('div',{staticClass:"container"},[_c('p',[_vm._v("Все права защищены (C) "+_vm._s(new Date().getFullYear()))])])])}
var staticRenderFns = []

export { render, staticRenderFns }